import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { useWishlist } from "../context/WishlistContext";
import { useAuth } from "../context/AuthContext";
import ProductCard from "../components/shop/ProductCard";
import { Heart } from "lucide-react";

export default function WishlistPage() {
  const { wishlist } = useWishlist();
  const { user } = useAuth();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      if (!wishlist.length) { setProducts([]); setLoading(false); return; }
      const fetched = await Promise.all(
        wishlist.map(id => getDoc(doc(db, "products", id)).then(s => s.exists() ? { id: s.id, ...s.data() } : null))
      );
      setProducts(fetched.filter(Boolean));
      setLoading(false);
    }
    load();
  }, [wishlist]);

  if (!user) return (
    <div style={{ textAlign: "center", padding: 80 }}>
      <p style={{ marginBottom: 16, color: "var(--text-muted)" }}>Sign in to see your wishlist.</p>
      <Link to="/login" className="btn btn-primary">Sign In</Link>
    </div>
  );

  return (
    <div style={{ background: "var(--surface)", minHeight: "100vh" }}>
      <div className="container section-sm">
        <h1 style={{ fontFamily: "var(--font-head)", fontSize: 28, fontWeight: 700, marginBottom: 8 }}>My Wishlist</h1>
        <p style={{ color: "var(--text-muted)", marginBottom: 32 }}>{products.length} saved item{products.length !== 1 ? "s" : ""}</p>
        {loading ? <div className="loader"><div className="spinner" /></div>
          : products.length === 0 ? (
            <div style={{ textAlign: "center", padding: "60px 20px" }}>
              <Heart size={48} style={{ marginBottom: 16, opacity: 0.2 }} />
              <h3 style={{ fontFamily: "var(--font-head)", marginBottom: 8 }}>Your wishlist is empty</h3>
              <p style={{ color: "var(--text-muted)", marginBottom: 24 }}>Save products you love by clicking the heart icon.</p>
              <Link to="/shop" className="btn btn-primary">Browse Products</Link>
            </div>
          ) : (
            <div className="product-grid">
              {products.map(p => <ProductCard key={p.id} product={p} />)}
            </div>
          )}
      </div>
    </div>
  );
}
